module.exports = __webpack_public_path__ + "media/svg/calendar-81fcad21.svg";